<template>
  <div class="box-input">
    <!-- 手机号 -->
    <div class="account-number">
      <el-button plain>+86</el-button>
      <el-input
        class="account-input"
        v-model="myphonenum"
        placeholder="请输入手机号"
        autocomplete="off"
        :class="{ 'focus-border': mydata.focusPhone }"
        @focus="mydata.focusPhone = true"
        @blur="mydata.focusPhone = false"
      />
    </div>

    <!-- 验证码 -->
    <div class="box-password">
      <el-input
        class="password-input"
        v-model="myphonecode"
        placeholder="请输入验证码"
        :class="{ 'focus-border': mydata.focusCode }"
        @focus="mydata.focusCode = true"
        @blur="mydata.focusCode = false"
      />
      <!-- 获取验证码 -->
      <el-button
        class="password-button"
        @click="getphoncode"
        :disabled="mydata.btnDisabled"
        >{{ mydata.btnText }}</el-button
      >
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from "vue";
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";
import { User, Lock } from "@element-plus/icons-vue";

// 引入手机号验证码发送接口
import { forgetPasswordCode } from "@/api/login/retrievePasswordLogin/index.js";
import { isPhoneNumber } from "@/utils/validate.js";

const router = useRouter();

// 手机号
const myphonenum = defineModel("myphonenum");

// 验证码
const myphonecode = defineModel("myphonecode");

var mydata = reactive({
  btnText: "获取验证码",
  btnDisabled: false,

  btnLoading: false,

  checked1: false,

  form: {
    phone: "",
    code: "",
  },
  ////
  focusPhone: false,
  focusCode: false,
});

//获取验证码,按钮点击事件
function getphoncode() {
  // 如果不是手机号，那么提醒弹窗并终止代码
  if (isPhoneNumber(myphonenum.value) === false) {
    ElMessage({
      message: "手机号码格式错误",
      type: "warning",
    });
    return;
  }

  mydata.btnDisabled = true;
  let num = 60;
  let intervalId = setInterval(() => {
    num = num - 1;
    mydata.btnText = num + "秒后可重发";
    if (num === 0) {
      mydata.btnText = "获取验证码";
      clearInterval(intervalId);
      mydata.btnDisabled = false;
    }
  }, 1000);

  // 调用forgetPasswordCode方法，发送请求
  forgetPasswordCode({
    type:"phone",
    account: myphonenum.value,
  }).then((res) => {
    // // 提示弹窗
    ElMessage({
      message: res.msg,
      type: "success",
    });
  }).catch((err)=>{
      mydata.btnText = "获取验证码";
      clearInterval(intervalId);
      mydata.btnDisabled = false;
  })
}
</script>

<style scoped lang="scss">
.box-input {
  .account-number,
  .box-password {
    display: flex;
    height: 48px;
    margin-bottom: 15px;
    //账号按钮
    :deep(.el-button.is-plain) {
      // border:1px solid red;
      border: 1px solid #dbdbdb;
      width: 65px;
      height: 48px;
      border-right: 0px;
      border-radius: 4px 0px 0px 4px;
      margin-bottom: 0px;
    }

    //密码按钮
    :deep(.el-button.password-button) {
      // border:1px solid red;
      border: 1px solid #dbdbdb;
      width: 100px;
      height: 48px;
      font-size: 15px;
      border-left: 0px;
      border-radius: 0px 4px 4px 0px;
      margin-bottom: 0px;
    }

    //账号输入框
    :deep(.el-input.account-input > .el-input__wrapper) {
      border-radius: 0px 4px 4px 0px;
      border: 1px solid #dbdbdb;
    }
    //密码输入框
    :deep(.el-input.password-input > .el-input__wrapper) {
      border-radius: 4px 0px 0px 4px;
      border: 1px solid #dbdbdb;
    }
  }

  //整个输入框
  :deep(.el-input) {
     width: 358px !important;
    height: 48px;
    margin-bottom: 15px;
  }
  //整个输入框
  :deep(.el-input > .el-input__wrapper) {
    box-shadow: none;
    // border: 1px solid #dbdbdb;
    // border: 1px solid red;
    > .el-input__inner {
      font-size: 15px;
      // color:red;
    }
  }

  :deep(.el-input.el-input--suffix) {
    // border:1px solid blue;
    margin-bottom: 0px;
  }
  //输入框中提示文字
  :deep(.el-input__wrapper > .el-input__inner::placeholder) {
    color: #666666;
    font-size: 14px;
    font-weight: 300;
    // color:blue;
  }
}

//鼠标在输入框中时，边框变蓝色
.focus-border {
  :deep(.el-input__wrapper) {
    border: 1px solid #409eff !important;
    .el-icon {
      color: #409eff;
    }
  }
}
</style>
